/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [{
  action: 'getAccountActivities',
  message: messages.SUCCESS_GET_ACCOUNT_ACTIVITIES,
  method: 'GET',
  path: '/account/:accountId/activities',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.GET_ACCOUNT_ACTIVITY,
  requestSchema: requestSchemas.accountActivities.getAccountActivities,
  scopes: [scopes.DEFAULT],
}];
